const awsmobile = {
  Auth: {
    type: 'API_KEY',
    apiKey: process.env.VUE_APP_AWS_API_KEY,
  },
};

export default awsmobile;
